import { useState } from 'react';

const faqs = [
  {
    question: 'Quels types de visas pouvez-vous m\'aider à obtenir ?',
    answer: 'Nous accompagnons nos clients pour tous les types de visas : tourisme/visite, affaires, étudiant, transit, regroupement familial, et bien d\'autres. Notre expertise couvre les destinations les plus demandées en Europe, Amérique du Nord, Asie et autres continents.'
  },
  {
    question: 'Combien de temps faut-il pour obtenir un visa ?',
    answer: 'Le délai varie selon le type de visa et le pays de destination. En moyenne, comptez 2 à 4 semaines pour la constitution du dossier et l\'obtention du visa. Certains visas peuvent être plus rapides (1-2 semaines) tandis que d\'autres nécessitent plus de temps (6-8 semaines). Nous vous informons des délais précis lors de la consultation.'
  },
  {
    question: 'Garantissez-vous l\'obtention du visa ?',
    answer: 'Bien que nous ne puissions garantir à 100% l\'obtention d\'un visa (la décision finale appartient au consulat), notre taux de succès est très élevé grâce à notre expertise et notre préparation minutieuse des dossiers. Nous maximisons vos chances en constituant des dossiers solides et conformes aux exigences consulaires.'
  },
  {
    question: 'Que se passe-t-il si mon visa est refusé ?',
    answer: 'En cas de refus, nous offrons un service d\'analyse approfondie pour comprendre les raisons du refus. Nous vous aidons ensuite à corriger les problèmes identifiés et à préparer une nouvelle demande avec une stratégie optimisée. Notre service d\'assistance après refus a aidé de nombreux clients à transformer un refus en succès.'
  },
  {
    question: 'Combien coûtent vos services ?',
    answer: 'Nos tarifs varient selon le type de service et la complexité de votre dossier. Nous proposons une consultation gratuite pour évaluer vos besoins et vous fournir un devis personnalisé. Nos prix sont transparents et compétitifs, sans frais cachés.'
  },
  {
    question: 'Dois-je me déplacer à votre bureau ?',
    answer: 'Non, ce n\'est pas obligatoire. Nous pouvons gérer l\'ensemble du processus à distance via WhatsApp, email et appels téléphoniques. Cependant, si vous préférez un rendez-vous en personne à notre bureau de Lomé, nous serons ravis de vous recevoir.'
  },
  {
    question: 'Quels documents dois-je fournir ?',
    answer: 'Les documents requis varient selon le type de visa et votre situation personnelle. Lors de la consultation initiale, nous vous fournirons une liste détaillée et personnalisée des documents nécessaires. Nous vous guidons également dans l\'obtention des documents manquants.'
  },
  {
    question: 'Préparez-vous vraiment aux entretiens consulaires ?',
    answer: 'Oui, absolument ! Notre préparation à l\'entretien consulaire est l\'un de nos services les plus appréciés. Nous organisons des sessions de coaching de 30 à 45 minutes avec simulation d\'entretien, questions fréquentes, conseils comportementaux et techniques de réponses. Vous aborderez l\'entretien avec confiance et assurance.'
  },
  {
    question: 'Puis-je suivre l\'avancement de mon dossier ?',
    answer: 'Oui, nous assurons un suivi régulier et transparent de votre dossier. Vous recevrez des mises à jour à chaque étape importante du processus. Notre équipe reste disponible pour répondre à vos questions et vous tenir informé en permanence.'
  },
  {
    question: 'Aidez-vous aussi pour les visas étudiants ?',
    answer: 'Oui, nous avons un service complet d\'accompagnement étudiant international. Nous vous aidons dans le choix des programmes, la recherche d\'admission, la préparation du dossier académique, l\'obtention du visa étudiant et même les conseils pour l\'installation dans le pays d\'accueil.'
  }
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-teal-100 px-4 py-2 rounded-full mb-4">
            <i className="ri-question-line text-teal-600"></i>
            <span className="text-teal-700 text-sm font-semibold">FAQ</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Questions Fréquentes
          </h2>
          <p className="text-xl text-gray-600">
            Trouvez rapidement les réponses à vos questions les plus courantes
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer hover:bg-gray-50 transition-colors"
              >
                <h3 className="text-lg font-bold text-gray-900 pr-8">
                  {faq.question}
                </h3>
                <div className={`w-8 h-8 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-teal-600 text-xl"></i>
                </div>
              </button>
              
              <div 
                className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`}
              >
                <div className="px-8 pb-6">
                  <p className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center bg-white rounded-2xl p-8 shadow-lg">
          <i className="ri-customer-service-2-line text-5xl text-teal-600 mb-4"></i>
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Vous avez d'autres questions ?
          </h3>
          <p className="text-gray-600 mb-6">
            Notre équipe est disponible pour répondre à toutes vos questions spécifiques
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://wa.me/22892620409" 
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center bg-teal-600 text-white px-6 py-3 rounded-full hover:bg-teal-700 transition-all font-semibold whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              WhatsApp
            </a>
            <a 
              href="mailto:clevisa22@gmail.com"
              className="inline-flex items-center bg-gray-100 text-gray-700 px-6 py-3 rounded-full hover:bg-gray-200 transition-all font-semibold whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line mr-2"></i>
              Email
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
